import _ from 'underscore';


export const paginatedList = (apiResponse) => {
    if (!apiResponse)
        return null;
    let {
        Items,
        CurrentPage,
        NumItemsPerPage,
        TotalItems,
        TotalPages
    } = apiResponse;

    return {
        items: Items,
        currentPage: CurrentPage,
        itemsPerPage: NumItemsPerPage,
        totalItems: TotalItems,
        pages: TotalPages
    };
};

export const photo = (apiPhoto) => {
    if (!apiPhoto)
        return null;
    let {
        Id,
        Url
    } = apiPhoto;

    return {
        id: Id,
        url: Url
    };
};

export const expertise = (apiExpertise) => {
    if (!apiExpertise)
        return null;
   let {
       Name,
       Id,
       CategoryType,
       Sort
   } = apiExpertise;

   return {
       name: Name,
       id: Id,
       categoryType: CategoryType,
       sort: Sort
   };
};

export const category = (apiCategory) => {
    if (!apiCategory)
        return null;
    let {
        Id,
        Name
    } = apiCategory;

    return {
        display: Name,
        value: Id
    };
};

export const auction = (apiAuction) => {
    if (!apiAuction)
        return null;
    let {
        Id,
        Title,
        UserId,
        Description,
        AuctioneerName,
        AuctioneerCity,
        AuctioneerState,
        AuctioneerDesignations,
        AudioTourUrl,
        'Date': date,
        BeginTime,
        Categories,
        EndDate,
        EndTime,
        Photos,
        BiddingUrl,
        BiddingProviderUrl,
        DetailedCharacteristics,
        VideoUrl,
        Terms,
        Directions,
        IsPremium,
        City,
        State,
        Street,
        ZipCode,
        Bathrooms,
        Bedrooms,
        LivingArea,
        LotSize,

        NeighborhoodName,
        YearBuilt,
        PropertyStyle, // { "Name": "Italianate", "Id": 23 }
        PropertyType, // { "Name": "MultiFamily", "Id": 5 }
        Units,

        // Internationalization fields
        CountryId,
        Currency,
        GuidePrice,

        // UK/Ireland specific fields
        EpcRating,      // UK Energy Performance Certificate (A-G)
        BerRating,      // Ireland Building Energy Rating (A1-G)
        Eircode,        // Ireland postal code
        Tenure,         // UK: Freehold/Leasehold
        CouncilTaxBand, // UK Council Tax Band (A-H)
        GroundRent,     // UK annual ground rent for leasehold
        LeaseYearsRemaining, // UK years left on lease

        // Additional UK/Ireland property fields
        HeritageStatus,
        PropertySubtype,
        HasGarden,
        HasParking,
        ParkingSpaces,
    } = apiAuction;

    const isRealEstate = !!(
        Categories && _(Categories).find(({ Name }) => Name === 'Real Estate')
    );

    let characteristics = {};
    if (DetailedCharacteristics) {
        characteristics = _({
            'appliances': 'Appliances',
            'architecturalStyle': 'ArchitecturalStyle',
            'coolingSystem': 'CoolingSystemType',
            'exterior': 'ExteriorType',
            'flooring': 'FloorCovering',
            'heatingFuel': 'HeatingFuel',
            'heatingSystem': 'HeatingSystem',
            'roofing': 'RoofType',
            'styleType': 'StyleType',
            'viewType': 'ViewType',
        }).mapObject((apiKey) => {
            const apiCharacteristics = DetailedCharacteristics[apiKey];

            if (!apiCharacteristics) return null;

            let charNames = _(apiCharacteristics).map(characteristicItem => {
                const { Name = '' } = characteristicItem || {};
                return Name;
            });
            charNames = _(charNames).compact()
            return charNames.join(', ') || null;
        });
    }

    return {
        id: Id,
        title: Title,
        userId: UserId,
        description: Description,
        auctioneerName: AuctioneerName,
        auctioneerCity: AuctioneerCity,
        auctioneerState: AuctioneerState,
        auctioneerDesignations: AuctioneerDesignations,
        audioTourUrl: AudioTourUrl && AudioTourUrl.replace(/([^:]\/)\/+/g, '$1'),
        date,
        beginTime: BeginTime,
        categories: _(Categories).map(category),
        endDate: EndDate,
        endTime: EndTime,
        photos: _(Photos).map(photo),
        biddingUrl: BiddingProviderUrl,
        videoUrl: VideoUrl,
        companyWebsite: BiddingUrl,
        terms: Terms,
        premium: IsPremium,
        directions: Directions,
        city: City,
        state: State,
        street: Street,
        zip: ZipCode,

        isRealEstate,
        bathrooms: Bathrooms,
        bedrooms: Bedrooms,
        livingArea: LivingArea,
        lotSize: LotSize,

        neighborhood: NeighborhoodName,
        yearBuilt: YearBuilt,
        propertyStyle: PropertyStyle && PropertyStyle.Name,
        propertyType: PropertyType && PropertyType.Name,
        units: Units,
        ...characteristics,

        // Internationalization
        countryId: CountryId,
        currency: Currency,
        guidePrice: GuidePrice,

        // UK/Ireland specific
        epcRating: EpcRating,
        berRating: BerRating,
        eircode: Eircode,
        tenure: Tenure,
        councilTaxBand: CouncilTaxBand,
        groundRent: GroundRent,
        leaseYearsRemaining: LeaseYearsRemaining,

        // Additional UK/Ireland property fields
        heritageStatus: HeritageStatus,
        propertySubtype: PropertySubtype,
        hasGarden: HasGarden,
        hasParking: HasParking,
        parkingSpaces: ParkingSpaces,
    };
};

export const auctioneer = (apiAuctioneer) => {
    if (!apiAuctioneer)
        return null;
    let {
        WebAddress,
        Title,
        Company,
        Phone,
        Address,
        Email,
        PhotoUrl,
        FirstName,
        LastName,
        City,
        State,
        ZipCode,
        Id,
        Expertise,
        Bio,
        Designations,
    } = apiAuctioneer;

    return {
        webAddress: WebAddress,
        title: Title,
        company: Company,
        phone: Phone,
        address: Address,
        email: Email,
        photoUrl: PhotoUrl,
        firstName: FirstName,
        lastName: LastName,
        city: City,
        state: State,
        zip: ZipCode,
        id: Id,
        bio: Bio,
        designations: Designations,
        expertise: _(Expertise).map(expertise)
    };
};
